<ion-app>
  <!-- Global Backdrop -->
  @if (backdrop$ | async) {
  <div class="global-backdrop" [@backdrop] (click)="onBackdropClick()"></div>
  }

  <div class="flex w-full min-h-screen" [inert]="commandPaletteService.isOpen()">
    <!-- State Inspector Panel -->
    <!-- <app-state-inspector-panel /> -->

    <!-- Main Content Area -->
    <div class="flex-1 relative">
      <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>

      <!-- Bottom Nav Bar -->
      <app-global-nav-bar class="lg:hidden"></app-global-nav-bar>
    </div>
  </div>

  <!-- Global Bottom Sheet -->
  <app-bottom-sheet />

  <!-- Global Command Palette -->
  <app-command-palette [isOpen]="commandPaletteService.isOpen()" [contentTemplate]="commandPaletteService.content()"
    [placeholder]="commandPaletteService.placeholder()" (close)="closeCommandPalette()"
    (searchChange)="onCommandPaletteSearchChange($event)" />

  <!-- Global Action Dialog -->
  <app-action-dialog [isOpen]="(actionDialogVisible$ | async) ?? false" [title]="(actionDialog$ | async)?.title"
    [maxWidth]="(actionDialog$ | async)?.maxWidth ?? 700"
    [showCloseButton]="(actionDialog$ | async)?.showCloseButton ?? true"
    [showDoneButton]="(actionDialog$ | async)?.showDoneButton ?? true"
    [doneButtonText]="(actionDialog$ | async)?.doneButtonText ?? 'Done'"
    [doneButtonColor]="(actionDialog$ | async)?.doneButtonColor ?? 'purple'" [closeOnBackdropClick]="
      (actionDialog$ | async)?.closeOnBackdropClick ?? true
    " [closeOnEscape]="(actionDialog$ | async)?.closeOnEscape ?? true"
    [customClass]="(actionDialog$ | async)?.customClass" [color]="(actionDialog$ | async)?.color ?? 'surface'"
    (close)="closeActionDialog()">
    <ng-container *ngTemplateOutlet="(actionDialog$ | async)?.content"></ng-container>
  </app-action-dialog>

  <!-- Global Action Bar -->
  <!-- <app-panel-action-bar /> -->
</ion-app>